import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader, SiteFooter } from "@/components/blog/SiteHeader";
import { BookingEmbed } from "@/lib/booking";

const SITE = "https://threedaylaunch.com";
const PATH = "/book";
const TITLE = "Book a Free Call — Three Day Launch";
const DESCRIPTION =
  "Schedule your free website strategy call with Three Day Launch. Choose a time that works for you and launch a custom website in just 3 days.";

export const Route = createFileRoute("/book")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: `${SITE}${PATH}` }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: TITLE,
          url: `${SITE}${PATH}`,
          description: DESCRIPTION,
          publisher: { "@type": "Organization", name: "Three Day Launch" },
        }),
      },
    ],
  }),
  component: BookPage,
});

function BookPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <SiteHeader hideBookCall />

      <main className="flex-1">
        <section className="bg-background px-4 py-16 md:py-24">
          <div className="mx-auto max-w-3xl text-center">
            <p className="mb-3 text-xs font-bold uppercase tracking-wider text-primary">
              Three Day Launch
            </p>
            <h1 className="mb-4 font-heading text-3xl font-bold text-foreground md:text-5xl">
              Book your free call
            </h1>
            <p className="mx-auto max-w-xl text-base text-muted-foreground md:text-lg">
              Pick a time that works for you. We&apos;ll talk through your goals,
              answer your questions, and map out a custom website plan.
            </p>
          </div>
        </section>

        <section className="px-4 pb-16 md:pb-24">
          <div className="mx-auto max-w-5xl overflow-hidden rounded-2xl border border-border bg-card shadow-xl">
            <div className="h-[70vh] min-h-[500px] w-full">
              <BookingEmbed />
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
